import OwnableTheme from '@Theme';
import React, { useState } from 'react';
import type { PressableProps } from 'react-native';
import { Pressable } from 'react-native';
import styled from 'styled-components/native';

type Props = Partial<PressableProps> & {
  children?: JSX.Element;
};

const ButtonWrapper = styled(Pressable)<{ clicked?: boolean }>`
  width: 40px;
  height: 40px;
  background-color: ${({ clicked }) =>
    clicked ? OwnableTheme.colors.lightGray : OwnableTheme.colors.white};
  border-radius: 50%;
  box-shadow: 0 0 13px #9b9b9b;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
`;

export const ZoomButton = ({ children, ...rest }: Props) => {
  const [clicked, setClicked] = useState(false);
  return (
    <ButtonWrapper
      clicked={clicked}
      onPressIn={() => {
        setClicked(true);
      }}
      onPressOut={() => {
        setClicked(false);
      }}
      {...rest}
    >
      {children}
    </ButtonWrapper>
  );
};
